/**
 * Reads the eSign field name contract owned by firm-portal's
 * esign-field-naming.util.ts (`{prefix}_{recipientId}_{timestamp}`). Client-portal only ever
 * reads names placed by firm-portal placement, so only the parsing half is ported here.
 */

export type EsignFieldType = 'SIGNATURE' | 'DATE_SIGNED';

const PREFIX_TO_FIELD_TYPE: Record<string, EsignFieldType> = {
  sig: 'SIGNATURE',
  date: 'DATE_SIGNED',
};

export interface ParsedEsignFieldName {
  fieldType: EsignFieldType;
  recipientId: number;
  timestamp: number;
}

/**
 * Parses a field name into its parts. Returns null for names that don't match the contract
 * (e.g. fields placed by another scheme) — three underscore-delimited parts required.
 */
export function parseEsignFieldName(name: string | null | undefined): ParsedEsignFieldName | null {
  const parts = name?.split('_');
  if (!parts || parts.length !== 3) {
    return null;
  }

  const [prefix, recipientIdStr, timestampStr] = parts;
  const fieldType = PREFIX_TO_FIELD_TYPE[prefix];
  const recipientId = Number(recipientIdStr);
  const timestamp = Number(timestampStr);

  if (!fieldType || Number.isNaN(recipientId) || Number.isNaN(timestamp)) {
    return null;
  }

  return { fieldType, recipientId, timestamp };
}
